<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column mu-w-100 mu-gap-04">
            <div class="mcc-row">
                <section class="mcc-col mu-d-flex mu-flex-row mu-align-items-center">
                    <h1 class="mu-mb-00">External system details</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section class="mcc-col mu-d-flex mu-justify-content-end mu-align-items-center">
                    <div role="group" class="mcc-button-group">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <nav aria-label="breadcrumb" class="">
            <ol class="mcc-breadcrumb">
                <li>Integrate</li>
                <li>
                    <a class="linkCode" @click="redirectToList()">External systems</a>
                </li>
                <li aria-current="page">{{externalSystemName}}</li>
            </ol>
        </nav>
        <div class="mcc-card mu-p-06 mu-overflow-hidden">
            <div>
                <div class="mcc-col colSpinner" v-if="!fetchCall">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="mcc-row">
                    <div class="mcc-col">
                        <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-if="isReadOnly">
                            <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                            <div class="mu-d-flex mu-flex-column">
                                <div class="mu-fw-semi-bold">Warning!</div>
                                <p class="mu-mb-00">{{readOnlyMsg}}</p>
                            </div>
                        </mcc-alert>
                    </div>
                </div>
                <div class="mcc-row" v-show="fetchCall">
                    <div>
                        <form ref="externalSystemForm" id="externalSystemForm" @submit.prevent="saveExternalSystem()" novalidate>
                            <div style="position:relative">
                                <div v-if="!updateCallES" class="spinner-overlay">
                                    <div class="spinner-background"></div>
                                    <div class="spinner-flex">
                                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        </svg>
                                    </div>
                                </div>
                                <div class="mcc-card">
                                    <div class="mcc-card__header">
                                        <h2 class="mcc-card__title">Details</h2>
                                    </div>

                                    <div class="mcc-card__body mu-mt-02">
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width">
                                                    <label for="name" class="mfc-label--required mu-mb-00">Name</label>
                                                    <input type="text" id="name" name="name" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.name" :pattern="nameWithoutSpaces" @change="updateName($event)" />
                                                </div>
                                                <div class="mfc-textarea-wrapper mfc-form-input-container mfc-form-input-wrapper--width mu-mb-03">
                                                    <label for="description" class="mfc-label--required mu-mb-00">Description</label>
                                                    <textarea id="description" name="description" required="" maxlength="100" :disabled="isReadOnly" ref="description" placeholder="Description" :value="dto.description" @input="dto.description = $event.target.value" @change="updateDescription($event)" rows="2" :pattern="descRegex"></textarea>
                                                    <div  class="mfc-invalid-feedback">
                                                        
                                                    </div>
                                                    <div class="mfc-help-text mu-mt-00">
                                                        <span v-if="dto.description">You have {{100 - dto.description.length}} characters remaining</span>
                                                        <span v-else>You have 100 characters remaining</span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container mu-mb-03">
                                                        <input type="checkbox" id="requireMapping" class="mfc-switch" :disabled="isReadOnly" name="requireMapping" :checked="dto.requiresUserMapping" @change="updateRequireMapping($event)" />
                                                        <label for="requireMapping">Requires user mapping ?</label>
                                                    </div>
                                                </div>
                                                <div class="mfc-input-wrapper mu-d-block mfc-form-input-container mfc-form-input-wrapper--width" v-if="dto.requiresUserMapping">
                                                    <label for="defaultAliasId" class="mfc-label--required mu-mb-00">Default user name
                                                        alias</label>
                                                    <input type="text" id="defaultAliasId" name="defaultAlias" required="" placeholder="Default user name alias" maxlength="50" :disabled="isReadOnly" ref="defaultAlias" @change="updateAlias($event)" :value="dto.defaultAlias" :pattern="nameRegex" />
                                                </div>
                                                <div class="mu-mt-05">
                                                    <div class="mfc-checkbox-wrapper mfc-form-input-container">
                                                        <input type="checkbox" class="mfc-switch" :disabled="isReadOnly" id="supportHierarchyImport" name="supportHierarchyImport" :checked="dto.importHierarchicalGroups" @change="dto.importHierarchicalGroups = $event.target.checked" />
                                                        <label for="supportHierarchyImport">Supports hierarchy import ?</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mcc-card__footer">
                                        <div class="mu-d-flex mu-justify-content-end " v-if="!isReadOnly">
                                            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                            <button type="button" class="mcc-button mcc-button--soft-danger" id="deleteBtn" @click="$refs.deleteExternalSystem.show()" title="Delete">
                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Delete</span>
                                            </button>

                                            <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit">
                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Save</span>
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="mcc-row mu-mt-05" v-show="fetchCall">
                    <div>
                        <div style="position:relative">
                            <div v-if="!updateCall" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div class="mcc-card">
                                <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap">
                                    <div>
                                        <h2 class="mcc-card__title">APIs</h2>
                                    </div>
                                    <div class="mu-d-flex">
                                        <div v-if="!isReadOnly">
                                            <router-link :to="CONTEXT_PATH + '/integrate/externalsystems/'+dto.id+'/apis/new'">
                                                <button class="mcc-button mcc-button--sm mcc-button--soft-primary" id="addAPIBtn" title="Add API">
                                                    <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label ">Add API</span>
                                                </button>
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="mcc-card__body mu-mt-02">
                                    <mcc-data-table ref="apiList" id="apiListTableId"></mcc-data-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-if="dataLoaded" ref="deleteExternalSystem" id="deleteExternalSystem">
            <div class="mcc-dialog__header">
                <h2 class="h4">Delete external system</h2>
                <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="$refs.deleteExternalSystem.close()">
                    <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                    <span class="mcc-button__label">Button</span>
                </button>
            </div>
            <div class="mcc-dialog__body">
                <div v-if="!isUserAssociated">
                    Are you sure you want to delete this external system?
                </div>
                <div v-if="isUserAssociated">
                    External system is associated with the user. Continue?
                </div>
            </div>
            <div class="mcc-dialog__footer">
                <div class="mcc-button-group mcc-button-group--spaced">
                    <button class="mcc-button mcc-button--outline" @click="$refs.deleteExternalSystem.close()">No</button>
                    <button class="mcc-button mcc-button--danger" @click="deleteExternalSystem($event)">Yes</button>
                </div>
            </div>
        </dialog>
    </div>
</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage, checkFormAndTextareaValidations
} from '../../../formvalid.js';

export default {
    name: "ExternalSystemEdit",
    data() {
        return {
            dto: {
                requiresUserMapping: false
            },
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["externalsystem.edit"],
            nameRegex: constantMessages.PATTERNS["name"],
            descRegex: constantMessages.PATTERNS["description"],
            nameWithoutSpaces: constantMessages.PATTERNS["nameWithoutSpaces"],
            externalSystemId: this.$route.params.externalSystemId,
            dataLoaded: false,
            isUserAssociated: false,
            tableObj: null,
            apiData: [],
            currentPageSize: 10,
            externalSystemName: "",
            fetchCall: true,
            updateCall: false,
            updateCallES: true,
            isReadOnly: false,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"],
            tableData: [],
            filterList: [],
            filterActive: false,
            isDescriptionValid: true
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;
        ExternalSystemAPI.getExternaSystemInfo(self.externalSystemId)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(
                        self.CONTEXT_PATH + "/integrate/externalsystems"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external system"
                    });
                    return;
                }
                self.dataLoaded = true;
                self.dto = result.externalSystem;
                self.externalSystemName = self.dto.name;
                self.isUserAssociated = result.isUserAssociated;
                self.apiData = result.APIs;
                self.isReadOnly = self.dto.readOnly;
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.externalsystem.details"] + " - " + self.externalSystemName;
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(function () {
                self.fetchCall = true;
                self.initAPITable();
            });
    },
    methods: {
        updateAPIList(filteredList) {
            this.filterList = filteredList;
            this.filterActive = true;
            this.initAPITable();

        },
        filterFunctionList(filteredRows, filterValue) {
            return filteredRows.filter(function (r) {
                return (
                    r.name.toLowerCase().includes(filterValue.toLowerCase()) ||
                    r.activeConnectionName.toLowerCase().includes(filterValue.toLowerCase())
                );
            })
        },
        initAPITable() {
            let self = this;
            if (this.tableObj != null) {
                this.currentPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            this.tableObj = window.tableFactory.create(document.getElementById("apiListTableId"), {
                bordered: true,
                striped: true,
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                debounceTime: 1000,
                fixedHeight: true,
                emptyStatusRecords: {
                    icon: 'empty_folder',
                    title: 'No apis found',
                },
                pageSize: self.currentPageSize,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="linkCode" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        activeConnectionName: {
                            type: "string",
                            title: "Active connection",
                            template: '<a class="linkCode" data-api-id="{{id}}" conn-type="{{connectionType}}" data-conn-id="{{activeConnectionId}}">{{activeConnectionName}}</a>',
                            sortable: true
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCall = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }

                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection
                        return ExternalSystemAPI.getExternalSystemsAPI(self.externalSystemId, queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    obj.activeConnectionName = '';
                                    obj.activeConnectionId = '';
                                    if (obj.activeConnection != null && obj.activeConnection != '') {
                                        obj.activeConnectionName = obj.activeConnection.name;
                                        obj.activeConnectionId = obj.activeConnection.id;
                                    }
                                });
                            }
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                                self.tableData = result.data;
                            }
                            self.updateCall = true;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterList.length,
                            data: self.filterList
                        };
                        return responseData;
                    }
                },
                onPageChange: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        updateTemplate() {
            let self = this;
            self.$refs.apiList
                .querySelectorAll('td [class="linkCode"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            let referenceConn = $(targetEle).attr("data-conn-id");
                            let connectionType = $(targetEle).attr("conn-type");
                            let apiId = $(targetEle).attr("data-api-id");

                            if (reference != null && reference != "") {
                                self.$router.push(
                                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + reference
                                );
                            } else if (referenceConn != null && referenceConn != "") {
                                self.$router.push(
                                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + apiId + "/" + connectionType.toLowerCase() + "/" + referenceConn
                                );
                            }
                        }
                    });
                });

        },
        deleteExternalSystem(e) {
            this.$refs.deleteExternalSystem.close()
            let self = this;
            self.updateCallES = false;
            ExternalSystemAPI.deleteExternalSystem(self.externalSystemId)
                .then(result => {
                    self.updateCallES = true;
                    if (result != null) {
                        self.$router.push(
                            self.CONTEXT_PATH + "/integrate/externalsystems"
                        );
                        EventBus.$emit('success-notification', {
                            "msg": " External system deleted successfully"
                        });
                        return;
                    }

                });
        },
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto?.defaultAlias) {
                displayErrorMessage($(self.$refs.defaultAlias), constantMessages.MESSAGES["error.externalsystems.alias"])
                self.$refs.defaultAlias.classList.add("ms-is-invalid")
                invalid = true;
            }
            return invalid;
        },
        saveExternalSystem() {
            let self = this;
            let form = $('#externalSystemForm')
            if(!self.isDescriptionValid){
                return;
            }

            if (this.dto.description ) {
                if(!checkFormAndTextareaValidations('description',this.descRegex,form))
                    {
                        return;
                    }
            } else {
                $(self.$refs.description)[0].classList.remove("ms-is-invalid");
            }     

            if (!this.dto.requiresUserMapping) {
                this.dto.defaultAlias = null;
            }
            self.updateCallES = false;
            ExternalSystemAPI.saveExternalSystem(this.dto).then(response => {
                self.updateCallES = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                    self.externalSystemName = self.dto.name;
                    this.$router
                        .push(
                            this.CONTEXT_PATH + "/integrate/externalsystems/" + response.data.id
                        )
                        .catch(err => {});
                }
            });
        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameWithoutSpaces)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.name = event.target.value;
        },
        updateDescription(event) {
            let self = this;
            if (event.target.value.length > 100) {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.externalsystems.description.max"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            } else if (!event.target.value.match(this.descRegex) && event.target.value != "") {
                displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES["error.externalsystems.description.invalid"])
                self.$refs.description.classList.add("ms-is-invalid")
                self.isDescriptionValid = false;
            }
             else {
                self.$refs.description.classList.remove("ms-is-invalid")
                self.isDescriptionValid = true;
            }
            self.dto.description = event.target.value;
        },
        updateRequireMapping(event) {
            let self = this;
            this.dto.requiresUserMapping = event.target.checked
            if (!event.target.checked) {
                this.dto.defaultAlias = "";
            }
        },
        updateAlias(event) {

            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.defaultAlias), constantMessages.MESSAGES["error.externalsystems.alias"])
                self.$refs.defaultAlias.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.defaultAlias), constantMessages.MESSAGES["error.externalsystems.alias.max"])
                self.$refs.defaultAlias.classList.add("ms-is-invalid")
            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.defaultAlias), constantMessages.MESSAGES["error.externalsystems.alias.invalid"])
                self.$refs.defaultAlias.classList.add("ms-is-invalid")
            } else {
                self.$refs.defaultAlias.classList.remove("ms-is-invalid")
            }
            self.dto.defaultAlias = event.target.value;
        },
        exportFiles() {
            ImportExportAPI.exportFiles('EXTERNALSYSTEM', this.externalSystemId)
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        },
    }
};
</script>
